import React from 'react';
import PropTypes from 'prop-types';
import {
  Flex,
  ExtendedBox,
  ExtendedFlex,
  Heading,
  Body,
  NavLink,
  Numeral,
} from '../../../coreui';

import FadeIn from '../../../components/FadeIn';

const ExploreOpportunitiesSection2 = ({
  isVisible,
  linkButtonText,
  totalMembers,
  totalAmountFinanced,
  amountPaidOut,
}) => {
  return (
    <ExtendedBox
      boxSizing="border-box"
      width={[1, 1, 0.5, 0.5, 0.5]}
      px={['15%', '25%', '5%', '5%', '5%']}
      pt={[50, 50, 100, 160, 220]}
      pb={[100, 100, 100, 160, 220]}
    >
      <ExtendedFlex
        flexDirection="column"
        mr={['0', '0', '10%', '10%', '10%']}
        maxWidth={[null, null, 300, 380, 500]}
      >
        <FadeIn>
          <ExtendedBox
            m={0}
            mb={30}
            pb={30}
            borderColor="gray.7"
            borderBottom={1}
            opacity={isVisible ? '1' : '0'}
          >
            <Flex
              flexDirection="column"
            >
              <Heading
                type="H5"
                textTransform="uppercase"
                m={0}
                mb="0.2em"
              >
                Access
              </Heading>
              <Heading
                type="H7"
                lineHeight="1.8em"
                textTransform="uppercase"
                m={0}
                mb="0.8em"
              >
                Private Market Offerings.
              </Heading>
              {
                totalMembers ?
                  (
                    <Body
                      type="B2"
                      m={0}
                    >
                      {<Numeral value={totalMembers} format="0,0" />}+ investors have joined
                    </Body>
                  ) :
                  null
              }
            </Flex>
          </ExtendedBox>
          <ExtendedBox
            pb={30}
            borderColor="gray.7"
            borderBottom={1}
            mb={30}
            opacity={isVisible ? '1' : '0'}
          >
            <Flex
              flexDirection="column"
            >
              <Heading
                type="H5"
                textTransform="uppercase"
                m={0}
                mb="0.2em"
              >
                Invest
              </Heading>
              <Heading
                type="H7"
                lineHeight="1.8em"
                textTransform="uppercase"
                m={0}
                mb="0.8em"
              >
                In Real Estate Investment Trusts (“REITS”) and Private Placements.
              </Heading>
              {
                totalAmountFinanced ?
                  (
                    <Body
                      type="B2"
                      m={0}
                    >
                      {
                        <Numeral value={totalAmountFinanced} format="$0a" />
                      }+ invested on our streamlined platform
                    </Body>
                  ) :
                  null
              }
            </Flex>
          </ExtendedBox>
          <ExtendedBox
            opacity={isVisible ? '1' : '0'}
          >
            <Flex
              flexDirection="column"
              mb={60}
            >
              <Heading
                type="H5"
                textTransform="uppercase"
                m={0}
                mb="0.2em"
              >
                Earn
              </Heading>
              <Heading
                type="H7"
                lineHeight="1.8em"
                textTransform="uppercase"
                m={0}
                mb="0.8em"
              >
                Potential Cash Distributions.
              </Heading>
              {
                amountPaidOut ?
                  (
                    <Body
                      type="B2"
                      m={0}
                    >
                      Over {
                        <Numeral value={amountPaidOut} format="$0a" />
                      }+ in investor disbursements
                    </Body>
                  ) :
                  null
              }
            </Flex>
          </ExtendedBox>
        </FadeIn>
        <ExtendedBox
          display={['block', null, 'none']}
        >
          <FadeIn
            fadeInIndex={4}
          >
            <NavLink
              type="L1"
              to="/investment-options"
              opacity={isVisible ? '1' : '0'}
            >
              {linkButtonText}
            </NavLink>
          </FadeIn>
        </ExtendedBox>
      </ExtendedFlex>
    </ExtendedBox>
  );
};

ExploreOpportunitiesSection2.propTypes = {
  isVisible: PropTypes.bool,
  linkButtonText: PropTypes.string,
  totalMembers: PropTypes.number,
  totalAmountFinanced: PropTypes.number,
  amountPaidOut: PropTypes.number,
};

export default ExploreOpportunitiesSection2;
